import {
  useExperimentsModeContext,
  useRunsLineageOptions,
} from '@neptune/shared/leaderboard-business-logic';
import { LeaderboardEntryWithPermissions } from '@neptune/shared/leaderboard-domain';

export const useDetailsLinkRouteParams = (
  data: LeaderboardEntryWithPermissions,
  shortId: string | undefined,
  experimentName: string | undefined,
) => {
  const { experimentsOnlyEnabled } = useExperimentsModeContext();
  const [lineage] = useRunsLineageOptions();

  const runIdentificationKey = experimentName || shortId;

  return {
    organizationName: data.organizationName,
    projectName: data.projectName,
    runIdentificationKey,
    type: experimentName ? 'experiment' : 'run',
    tab: 'details',
    experimentsOnly: experimentsOnlyEnabled,
    runsLineage: lineage,
  };
};
